import React from 'react';
import {connect} from 'react-redux';
import {toggleViewFileDetailsSlider, toggleFileProgressBar, cancelPendingFiles, resetBrochureFileHistory} from '../../../actions/products';
import AnimateOnHover from 'jd-library/AnimateOnHover';
import styles from './scss/file-upload-progress.scss';

const FileUploadProgress = props => {
    const {
		uploadedCount=0,
		uploadPercentage=0,
		errorCount=0,
        allUploaded=false,
        previouslyUploadedCount=0,
	} = props.progressProps;
    let uploadTitle = allUploaded ? 'Upload Complete' : 'Uploading';
    const openViewDetailsSlider = () => {
        props?.isBrochure && props.toggleFileSlider ? props.toggleFileSlider() : props.toggleViewFileDetailsSlider({show: true});
    }

    const hideUploadProgressBar = () => {
       props.toggleFileProgressBar({show: false});
       if(props.isBrochure){
        props.resetBrochureFileHistory();
       } else {
           props.cancelPendingFiles({variantId: props.variantId});
       }
    }
   
    const totalFiles = props.fileAttachmentArr.length - previouslyUploadedCount;
    return(
        props.showProgressBar &&
        <>
            <div className={styles['file-upload-progress-main']}>
                <div className={styles['progress-container']}>
                    <div className={styles['progress-sub-container']}>  
                          <div className={styles['sub-container']}>
                            {errorCount == props.fileAttachmentArr.length ?
                            <span className={styles['upload-title']}>Upload Failed</span>
                            :
                            <span className={styles['upload-title']}>{uploadTitle}</span>
                            }
                            <span className={styles['upload-count']}>({uploadedCount}/{totalFiles} {(totalFiles > 1 ? 'Files' : 'File')})</span>
                            {errorCount && allUploaded ?
                            <span className={styles['error-count']}> - {errorCount} {errorCount > 1 ? 'Errors' : 'Error'}</span>
                            : null
                            }
                            {allUploaded ?
                            <>
                                <AnimateOnHover onClick={openViewDetailsSlider} className={`${styles['view-details-main']} ${errorCount ? 'view-details-with-error' : ''}`}>
                                    <span className={styles['view-details']}>View Details</span>
                                </AnimateOnHover>
                                <AnimateOnHover className={`${styles['cancel-progress-bar']} ${props.isMobile ? 'cancel-mobile' : ''}`} onClick={hideUploadProgressBar}>
                                    <span className={'icon-HDRcross'}></span>
                                </AnimateOnHover>
                            </>
                            : null }
                          </div>  
                    </div>
                    <div className={styles['progress-bar-container']}>   
                        <div className={`${styles['file-upload-progress-bar']} ${uploadPercentage > 0 ? 'show-background': 'hide-background'}`} style={{width : `${uploadPercentage}%`}}></div>
                    </div>  
                </div>
            </div>
        </>
    )
}


const mapStateToProps = (state,props) => {
    let fileAttachmentArr = state.products.allProducts[props.productId]?.fileAttachmentArr || [];
    if(!props.fromAttachment && !props.fromFileModule) {
        fileAttachmentArr = state.products.brochureAttachment.uploadingFiles;
    }
	return {
		...props,
          fileAttachmentArr,
          isMobile: state.deviceData.isMobile,
          ...state.products.fileAttachmentData
	}
}
export default connect(mapStateToProps, {
    toggleViewFileDetailsSlider, 
    toggleFileProgressBar, 
    cancelPendingFiles,
    resetBrochureFileHistory
})(FileUploadProgress);